import { Column } from 'react-data-grid'
import { SearchAppInfo } from 'domain/SearchAppInfo'
import { SizableImage } from 'app/components/Image'
import { AppCategory } from 'domain/AppCategory'
import { onImageLoadError } from 'app/utils/fileUtils'
import hotspotCircleGreen from 'assets/images/hotspot_circle_green.svg'
import hotspotCircle from 'assets/images/hotspot_circle.svg'

export const columnsConfig = (
    appCategories: AppCategory[],
    getAppImageUrl: (app: SearchAppInfo) => string,
): Column<SearchAppInfo>[] =>
    [
        { key: 'order', name: '#', width: 45 },
        {
            key: 'approved',
            name: '',
            width: 25,
            formatter: props =>
                props.row.approved ? (
                    <SizableImage url={hotspotCircleGreen} />
                ) : (
                    <SizableImage url={hotspotCircle} />
                ),
        },
        { key: 'id', name: 'APP ID', width: 45 },
        {
            key: 'appIcon',
            name: 'Icon',
            width: 45,
            formatter: props => (
                <SizableImage
                    url={getAppImageUrl(props.row)}
                    onError={onImageLoadError}
                />
            ),
        },
        { key: 'appName', name: 'App Name' },
        {
            key: 'appCategoryLookupId',
            name: 'Category',
            formatter: props => {
                const categoryId = props.row.category
                const category = appCategories.find(
                    cat => cat.id === categoryId,
                )
                return <p>{category?.appCategoryName}</p>
            },
        },
        { key: 'versionsAmount', name: '# APKS', width: 45 },
        { key: 'packageName', name: 'App Package' },
    ] as Column<SearchAppInfo>[]
